import { render, staticRenderFns } from "./JoinYage.vue?vue&type=template&id=0643deaa&scoped=true"
import script from "./JoinYage.vue?vue&type=script&lang=js"
export * from "./JoinYage.vue?vue&type=script&lang=js"
import style0 from "./JoinYage.vue?vue&type=style&index=0&id=0643deaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643deaa",
  null
  
)

export default component.exports